import rsdRaw from '../../public/data/rsd.json'
import cssRaw from '../../public/data/css.json'
import cddRaw from '../../public/data/cdd.json'
import type { AmbitoId } from './ambitiStats'

type RawStruttura = {
  Tipologia: string
  'Codice struttura': string
  'Denominazione struttura': string
  Indirizzo: string
  Comune: string
  CAP: string
  Ambito: string
  Telefono: string
  Email: string
  'Lista di attesa': string
  'Posti a contratto': string
  'Posti disponibili': string
  'Persone in lista': string
}

export interface StrutturaDisabilita {
  id: string
  nome: string
  comune: string
  indirizzo: string
  telefono: string
  email: string
  listaAttesa: boolean
  postiContratto: number
  postiDisponibili: number
  personeInLista: number
  ambitoId: AmbitoId
}

const AMBITO_MAP: Record<string, AmbitoId> = {
  'Monza': 'monza',
  'Carate Brianza': 'carate',
  'Desio': 'desio',
  'Seregno': 'seregno',
  'Vimercate': 'vimercate',
}

function slugify(value: string): string {
  return value
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '')
}

function parse(raw: RawStruttura[], prefix: string): StrutturaDisabilita[] {
  return raw.map((entry, index) => ({
    id: `${prefix}-${slugify(entry['Denominazione struttura'])}-${index}`,
    nome: entry['Denominazione struttura'],
    comune: entry.Comune,
    indirizzo: entry.Indirizzo,
    telefono: entry.Telefono,
    email: entry.Email,
    listaAttesa: entry['Lista di attesa'].trim().toUpperCase() === 'SI',
    postiContratto: parseInt(entry['Posti a contratto']) || 0,
    postiDisponibili: parseInt(entry['Posti disponibili']) || 0,
    personeInLista: parseInt(entry['Persone in lista']) || 0,
    ambitoId: AMBITO_MAP[entry.Ambito] ?? 'monza',
  }))
}

export const RSD_LIST: StrutturaDisabilita[] = parse(rsdRaw as RawStruttura[], 'rsd')
export const CSS_LIST: StrutturaDisabilita[] = parse(cssRaw as RawStruttura[], 'css')
export const CDD_LIST: StrutturaDisabilita[] = parse(cddRaw as RawStruttura[], 'cdd')
